export const domainUrl = `${window.location.protocol}//joelcalheiros.com`;
export const apiUrl = `${domainUrl}/admin/api`;